import { Injectable } from '@angular/core';
import { fromEvent, merge, timer, concat, BehaviorSubject } from 'rxjs';
import { debounceTime, map, startWith, switchMap, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class IdleDetectService {
    //for minutes => calculation should be (minute * 60 * 1000)
    //for seconds => calculation should be (seconds * 1000)

    // 15 sec for warning and 30 sec set for testing purpose.
    private warningTime = 60 * 60 * 1000; // 60 minutes
    private logoutTime = 75 * 60 * 1000; // 75 minutes
    private resetIdle$ = new BehaviorSubject(null); // Initialize a subject to reset idle timers

    public idleState = new BehaviorSubject<string>('');

    constructor() {
        const activityEvents$ = merge(
            fromEvent(document, 'mousemove'),
            fromEvent(document, 'keydown'),
            fromEvent(document, 'click')
        );

        const idle$ = activityEvents$.pipe(
            startWith(null),
            debounceTime(this.warningTime),
            switchMap(() => concat(
                timer(0).pipe(
                    map(() => 'Warning')
                ),
                timer(this.logoutTime - this.warningTime).pipe(
                    map(() => 'Timeout')
                )
            ))
        );

        // Reset the idle timer on user activity
        activityEvents$.subscribe(() => {
            if (this.idleState.value != 'Timeout') {
                this.resetIdle$.next(null); // Trigger the reset if still timeout not reached
                this.idleState.next('Active');
            }
        });

        this.resetIdle$.pipe(
            switchMap(() => idle$) // Restart the idle observable on reset
        ).subscribe(status => {
            this.idleState.next(status); // Publish the status
        });
    }
}
